<template>
  <div class="border rounded flex flex-col" v-if="showMe">
    <div class="px-2 mb-2 py-2">
      <h3>Totali per {{ title }}</h3>
    </div>
    <div class="flex justify-between mx-5" v-for="(value, key) in component">
      <div class="px-4">
        <p class="mb-0 py-2">{{ key }}</p>
      </div>
      <div class="px-3">
        <h2>{{ value }}</h2>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  props: ['component', 'title', 'is-lever'],

  computed: {
    showMe() {
      if ((!this.isLever && this.title === "Levette") || (!this.isLever && this.title === "Capotasti")) {
        return false;
      }
      return true
    }
  }

}
</script>